/**
 * Den ENE filen i portalen som rører den genererte klienten (`react-ts-
 * integration`; lint-vakten i eslint.config.js). Alt annet går gjennom
 * `@innspel/core`. Det som hentes her er én operasjon kjernen ikke eksponerer:
 * TV-overleveringen, reservert v2, som gir `/h/<id>` sin «utløpt»-tilstand.
 */
import type { HandoffsHandoffView as HandoffView } from '../generated/api/types.gen.ts';
import { handoffsGet } from '../generated/api/sdk.gen.ts';
import { createClient, createConfig } from '../generated/api/client/index.ts';

export type { HandoffView };

export type HandoffResultat = { status: 'ok'; handoff: HandoffView } | { status: 'utlopt' } | { status: 'utilgjengelig' };

/**
 * Henter TV-ens kontekst for `/h/<id>`. Ukjent, utløpt eller brukt → 404 → «utløpt».
 * 501 (reservert v2, M0.2) og nettverksfeil → «utilgjengelig»: portalen viser da
 * samme flate, uten konteksten. Anonymt — identiteten avgjøres på mobilen.
 */
export async function hentHandoff(baseUrl: string, tenantKey: string, id: string, hent: typeof fetch = fetch): Promise<HandoffResultat> {
  const client = createClient(createConfig({ baseUrl, fetch: hent }));
  try {
    const res = await handoffsGet({
      client,
      path: { id },
      headers: { 'X-Innspel-Tenant-Key': tenantKey },
      signal: AbortSignal.timeout(5_000),
    });
    const status = res.response?.status ?? 0;
    if (status === 404 || status === 410) return { status: 'utlopt' };
    if (!res.response?.ok || !res.data) return { status: 'utilgjengelig' };
    return { status: 'ok', handoff: res.data as HandoffView };
  } catch {
    return { status: 'utilgjengelig' };
  }
}
